import React from 'react';
import PayloadDescription from './PayloadDescription';

const Description = () => {
    return (
        <div>
            <p>
                <strong>Original Potential Payout</strong> is a helper that
                provides the utility of displaying the original potential
                payout, meaning the potential payout before adding a reward to
                betslip.
            </p>
            <div>
                The <strong>getOriginalPotentialPayout()</strong> method accepts
                an object ({'{}'}) as parameter. The object keys are:
                <PayloadDescription type="original" />
            </div>
            <p>
                Below, there is an example of the input data that is used to
                display the <strong>original potential payout</strong> value.
            </p>
        </div>
    );
};

export default Description;
